<template>
  <div v-if="tabelaVisivel">
    <div class="text-center" v-if="loadingTabela">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <b-table responsive="sm" :items="itemsTabela" :fields="fieldsTabela" per-page="10" bordered striped>
        <template #cell(interacao)="data">
          <div class="d-flex justify-content-end">
            <b-button size="sm" variant="primary" class="me-1" v-b-tooltip.hover="'Editar'"
              @click="editaremail(data.item)" :disabled="loadingAcoes">
              <i class="mdi mdi-pencil"></i>
            </b-button>
            <b-button size="sm" variant="danger" v-b-tooltip.hover="'Excluir'" @click="excluirEmail(data.item)"
              :disabled="loadingAcoes">
              <i class="mdi mdi-trash-can"></i>
              <b-spinner variant="primary" small class="ms-2" v-if="loadingAcoes"></b-spinner>
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="row align-items-center">
        <div class="col-md-10 text-center" v-if="!loadingTabela && !itemsTabela.length">
          <span class="fs-6 text-secondary">Nenhum email cadastrado para este cliente rural.</span>
        </div>
        <div
          :class="[itemsTabela.length > 0 ? 'col-12 d-flex justify-content-end' : 'col-md-2 d-flex justify-content-end']">
          <b-button variant="info" @click="incluiremail">
            <i class="fa fa-solid fa-plus me-2"></i>
            <span>Incluir</span>
          </b-button>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <div class="row">
      <div class="col-md-6">
        <b-form-group class="mb-3" label="Tipo de email" :state="state('selectTipoEmail')"
          invalid-feedback="Campo obrigatório">
          <multiselect v-model="selectTipoEmail" placeholder="Tipo Email" :options="tipoEmailOptions" label="label"
            track-by="value" selectLabel="" :max-height="230" />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="mb-3" label="Email" invalid-feedback="Digite um Email válido">
          <b-form-input v-model="email" type="email" trim autocomplete="off" placeholder="Digite o email"
            :state="state('email')" />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="m-auto">
        <b-form-checkbox plain value="S" unchecked-value="N" v-model="emailPrincipal" :disabled="disabledPrincipal">
          Email Principal
        </b-form-checkbox>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12 d-flex justify-content-between">
        <b-button @click="voltar" class="mt-1 me-1" variant="secondary" data-tooltip="Voltar"
          data-tooltip-location="bottom">
          <i class="mdi mdi-arrow-left-circle font-size-15"></i>
        </b-button>

        <b-button @click="salvar" variant="success" class="mt-1 me-1" data-tooltip="Salvar"
          data-tooltip-location="bottom" :disabled="!habilitaBotaoSalvar || loadingSalvar">
          <i class="mdi mdi-content-save"></i>
          <b-spinner class="ms-2" small variant="primary" v-if="loadingSalvar"></b-spinner>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import { required, email } from "vuelidate/lib/validators";
import { isCheckboxDisabled } from "@/utils/astec/validaContatoPrincipal";

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      tabelaVisivel: true,
      loadingTabela: true,
      loadingSalvar: false,
      submit: false,
      selectTipoEmail: null,
      email: "",
      emailPrincipal: false,
      tipoEmailOptions: [
        { value: "1", label: "Comercial" },
        { value: "9", label: "Particular" }
      ],
      itemsTabela: [],
      fieldsTabela: [
        {
          key: "DSEMAIL",
          label: "Email",
        },
        {
          key: "CDTIPO",
          label: "Tipo",
          formatter: (value) => {
            return  this.tipoEmailOptions.find(el => el.value === value).label;
          },
        },
        {
          key: "STPRINCIPAL",
          label: "Principal",
          formatter: (value) => {
            return  value === "S" ? "Sim" : "Não";
          },
        },
        {
          key: "interacao",
          class: "alinharCelulaDireita",
          label: "Ações",
        }
      ],
      sqEmail: null,
      sqCliente: null,
      loadingAcoes: false,
      disabledPrincipal: false,
      cdCooperado: null,
    };
  },

computed: {
    habilitaBotaoSalvar() {
      const camposPreenchidos = this.selectTipoEmail && this.email;
      const validacaoOk = !this.$v.$invalid;
      return camposPreenchidos && validacaoOk;
    }
  },

  created(){
    this.verificarClienteRuralAstec();
  },
  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },

    async verificarClienteRuralAstec(){
      if(this.$store.state.clienteRuralAstec){
        this.cdCooperado = this.$store.state.filtroClienteRuralAstec.cdCooperado ?? null;
        this.sqCliente = this.$store.state.clienteRuralAstec.ID ?? null;
        if(!this.sqCliente) {
          this.sqCliente = this.$store.state.clienteRuralAstec.dados.sq_cliente ?? null;
        }
        this.buscarTabelaEmailAstec();
      }
    },

    async buscarTabelaEmailAstec() {
      try {
        this.loadingTabela = true;
        const response = await this.$http.get("api/astec/getClienteRuralEmail/" + this.sqCliente + "/" + this.cdCooperado );
        this.itemsTabela = response.data;
        this.$emit("visibilidade-botao", true);
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loadingTabela = false;
      }
    },

    incluiremail() {
      this.tabelaVisivel = false;
      this.sqEmail = null;
      this.selectTipoEmail = null;
      this.email = null;
      if(this.itemsTabela.length == 0){
        this.emailPrincipal = "S";
        this.disabledPrincipal = true;
      } else {
        this.emailPrincipal = "N";
        this.disabledPrincipal = false;
      }
      this.$emit("visibilidade-botao", false);
    },

    excluirEmail(item){
      Swal.fire({
        title: "Tem certeza?",
        text: "Você realmente deseja excluir este E-mail de cliente rural? Essa ação não pode ser desfeita.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingAcoes = true;
          var obj = {
            sqCliente: this.sqCliente,
            sqEmail: item.SQEMAIL,
          };


          this.$http.post("/api/astec/deletarEmailClientesRurais", obj)
            .then(() => {
              Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "Email de cliente rural excluído com sucesso!",
              });
              this.verificarClienteRuralAstec();
            })
            .catch(err => {
              this.$tools.alerta(err.response.data, "error");
            })
            .finally(() => {
              this.loadingAcoes = false;
            });
        }
      });
    },

    editaremail(item) {
      this.tabelaVisivel = false;
      this.$emit("visibilidade-botao", false);
      this.sqEmail = item.SQEMAIL;
      this.email = item.DSEMAIL
      this.selectTipoEmail = this.tipoEmailOptions.find(el => el.value === item.CDTIPO);
      this.emailPrincipal = item.STPRINCIPAL === "S" ? "S" : "N";
      this.disabledPrincipal = isCheckboxDisabled(this.emailPrincipal);
    },

    voltar() {
      this.sqEmail = null;
      this.tabelaVisivel = true;
      this.$emit("visibilidade-botao", true);
    },

    async salvar() {
      this.loadingSalvar = true;
      this.submit = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loadingSalvar = false;
        return;
      }

      const obj = {
        sqCliente: this.sqCliente,
        dsEmail: this.email,
        cdTipo: this.selectTipoEmail.value,
        stPrincipal: this.emailPrincipal === "S" ? "S" : "N",
        sqEmail: this.sqEmail ?? null,
      };
      console.log(obj, "obj email");
      try {
        const response = await this.$http.post("api/astec/insertClienteRuralEmail", obj);
        if (response.data === "E-mail inválido!") {
          this.$tools.alerta(response.data, "error");
        } else {
          this.$tools.alerta("Cadastrado com sucesso", "success");
          this.tabelaVisivel = true;
          this.verificarClienteRuralAstec();
          console.log('Habilitando aba de endereços');
          this.$emit('enableTab', 'enderecos');
        }
      } catch (err) {
        let mensagemErro = err.response.data;
        if (mensagemErro.includes("Já existe E-mail cadastrado o Tipo de contato!")) {
          mensagemErro = "Já existe E-mail cadastrado o Tipo de Email!";
        }
        this.$tools.alerta(mensagemErro, "error");
      } finally {
        this.loadingSalvar = false;
      }
    },
  },

  validations: {
    selectTipoEmail: { required, },
    email: { required, email }
  },
};
</script>
